<template>
    <b-modal :id="'modal-gerenciar-arquivos-usuarios-' + this.usuario.id" size="xl" hide-footer centered title="Gerenciar Arquivos Usuários">
		<informacoes-usuario :usuario="usuarioSelecionado"/>
		<hr>
		<table-arquivos-usuario :usuario="usuarioSelecionado"/>
    </b-modal>
</template>

<script>
import InformacoesUsuario from "../usuario/InformacoesUsuario.vue";
import TableArquivosUsuario from "./TableArquivosUsuario.vue";

export default {
	components: { TableArquivosUsuario, InformacoesUsuario },
	name: "ModalGerenciarArquivosUsuario",
	props: [ "usuario" ],
	data() {
		return {
			usuarioSelecionado: this.usuario,
		};
	},

};
</script>



// WEBPACK FOOTER //
// src/components/GerenciarArquivosUsuarios/ModalGerenciarArquivosUsuario.vue